import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowsSquarePath = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M8.998 21.01h3.01c.55 0 1-.45 1-1s-.45-1-1-1h-3c-1.1 0-2-.9-2-2V6.42l1.29 1.29a.996.996 0 1 0 1.41-1.41l-3-3c-.1-.1-.21-.17-.33-.22a1 1 0 0 0-.38-.08c-.14 0-.26.03-.38.08s-.23.12-.33.22l-3 3a.996.996 0 0 0 .01 1.41c.39.39 1.02.39 1.41 0l1.29-1.29v10.59c0 2.21 1.79 4 4 4M17.618 20.93c.12.05.25.08.38.08l-.02.01c.14 0 .26-.03.38-.08s.23-.12.33-.22l3-3a.996.996 0 1 0-1.41-1.41l-1.29 1.29V7.01c0-2.21-1.79-4-4-4h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c1.1 0 2 .9 2 2v10.58l-1.29-1.29a.996.996 0 1 0-1.41 1.41l3 3c.1.1.21.17.33.22"
    />
  </svg>
);
export default SvgArrowsSquarePath;
